import React from 'react'
import Navbar from './NavBar';

const Header = () => {
    return (
        <header>
            <Navbar />
        </header>
    )
}

export default Header